export default __webpack_public_path__ + "static/media/github.37078ccf.svg";